import React from 'react';
import { PortalContext } from '../../../context/portal-context';
import { Notification, NotificationType } from '../notifications-types';
import { HuchaDiscountNameByType } from '../../benefits/bonos/shared/hooks/use-hucha-values';
import { discountHelper } from '../../../helpers/discountHelper';

const POSVENTA_VISIBILITY_MONTHS = 3;

const isBonoPosventaVisible = (creationDate?: number | Date | string | null): boolean => {
	if (!creationDate) return false;

	const createdAt = new Date(creationDate);
	if (isNaN(createdAt.getTime())) return false;

	const expiresAt = new Date(createdAt);
	expiresAt.setMonth(expiresAt.getMonth() + POSVENTA_VISIBILITY_MONTHS);

	const now = new Date();
	return now >= createdAt && now <= expiresAt;
};

export function useNotifications() {
	const { portalService } = React.useContext(PortalContext);

	const vehicles = portalService.getPersonVehicles().getValue();
	const { hasDiscount, getDiscountByName, formatNumberWithThousands } = discountHelper();
	const hasBonoPosventa = hasDiscount(HuchaDiscountNameByType.posventa);

	const notifications: Notification[] =
		vehicles?.vehicles.flatMap((vehicle) => {
			if (!vehicle) return [];

			const base = { vehicle };

			const notifications = [];

			if (vehicle.alertPreITV) {
				notifications.push({
					...base,
					notificationType: NotificationType.PreITV,
				});
			}

			if (vehicle.alertNextMaintenance) {
				notifications.push({
					...base,
					notificationType: NotificationType.Mantenimiento,
				});
			}

			return notifications;
		}) ?? [];

	if (hasBonoPosventa) {
		const posventaDiscount = getDiscountByName(HuchaDiscountNameByType.posventa);
		if (isBonoPosventaVisible(posventaDiscount?.voucher?.vgedCreationDate)) {
			const value = posventaDiscount ? `${formatNumberWithThousands(posventaDiscount.value.toString())}€` : undefined;
			notifications.push({ notificationType: NotificationType.BonoPosventa, value });
		}
	}

	return notifications;
}
